/**
 * Interface for the Board data. This must be in sync with the backend: "db.php"
 */

interface IBoardData {
    ID: string;
    Name: string;
    OverrideNames: string[];
    SheetPrice: number | null;
    UnitPrice: number | null;
    Materials: any; // TODO: create material interface type
    ProductImage: string;
    SheetWidth: number;
    SheetHeight: number;
    SheetThickness: number;
    CompatibleEdgings: string[] | null;
    Oriented: number;
    EdgeBandable: number;
    Duplungable: number;
    IsWorkTop: number;
}

export default IBoardData;
